import React from 'react';
import { ContainerWrapper, Container, ContainerItem, Footer } from 'react-design-components';
import { Box, IconButton } from '@material-ui/core';
import { TFunction } from 'i18next';
import { ComponentsEnum, FlowEnum } from '../../types';
import useMainLayout from './hooks/useMainLayout';
import { ArrowBack } from '@material-ui/icons';
import { useConfig } from 'react-commons';

export interface Props {
  navigationId?: ComponentsEnum;
  directAccess?: boolean;
  progress?: number;
  flow?: FlowEnum;
  t?: TFunction;
  pageTitle?: string;
  hideNavigation?: boolean;
  hidBackButton?: boolean;
  fullWidth?: boolean;
}

const MainLayout: React.FC<Props> = (props: any) => {
  const { children, fullWidth } = props;
  const config = useConfig();
  const { navigation, classes, handleHistoryBack } = useMainLayout(props);
  return (
    <ContainerWrapper maxWidth="lg" className={classes.root}>
      <Box>
        {config?.ENV.ENABLE_GO_BACK_BUTTON && !props.hidBackButton && (
          <div>
            <IconButton aria-label="zurück" color="default" onClick={handleHistoryBack}>
              <ArrowBack />
            </IconButton>
          </div>
        )}
        {props.hidBackButton && <div style={{ height: 10 }} />}
        <Container alignItems="flex-start" className={classes.content}>
          {!props.hideNavigation && (
            <ContainerItem xs={false} md={3} className={classes.navigation}>
              {navigation}
            </ContainerItem>
          )}
          <ContainerItem xs={12} md={!props.hideNavigation ? 9 : 12} className={classes.item}>
            <Box maxWidth={fullWidth ? undefined : 700}>{children}</Box>
          </ContainerItem>
        </Container>
      </Box>
      <div className={classes.footer}>
        <Footer onlyShowImpressum />
      </div>
    </ContainerWrapper>
  );
};

export default MainLayout;
